export const GAME_TITLE = 'Loose Associations';
export const MAX_MISTAKES = 4;
